import { AfterViewInit, Component } from "@angular/core";
import { Router } from "@angular/router";

/**
 * @whatItDoes General 404d handler component
 *
 * @howToUse
 * Http interceptor handle the requests
 *
 * @description
 *
 *If the requested url is not valid then the system redirect the application to this page
 *
 * @selector none
 * @ngModule AppDefaultRoutingModule
 */
@Component({
    template: `
        <div>
            <div class="sup-loadmask-wrapper">
                <div id="loading-indicator" class="loading-indicator">
                    <mat-card>
                        <div *ngIf="navigated" class="loading-indicator-content">
                            <div class="mkb-spinner"></div>
                            <span>
                                Kérem várjon / Please wait...
                            </span>
                        </div>
                        <div *ngIf="!navigated" class="loading-indicator-content">
                            <span>
                                Az oldal nem található / Page not found
                            </span>
                        </div>
                    </mat-card>
                </div>
            </div>
        </div>
    `
})
export class PageNotFoundComponent implements AfterViewInit {
    navigated = false;
    constructor(private router: Router) {
    }

    /**
     * Go to main page
     */
    public navigateBack(): void {
        this.navigated = true;
        this.router.navigate(["mkb3ds/login"]);
    }

    ngAfterViewInit(): void {
        // Called after ngOnInit when the component's or directive's content has been initialized.
        // Add 'implements AfterContentInit' to the class.
        setTimeout(() => {
            this.navigateBack();
        }, 3000);
    }
}
